import React, { useEffect, useState } from "react";
import { Col, Container, Row, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTablePagination,
} from "../../../Common/DataTable";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import {
  customerList,
  getFinanceById,
  rowSorting,
} from "../../../store/actions";
import Filters from "./Filters";

const Name = (value) => {
  return (
    value &&
    JSON.parse(value.amtaxsettlement_data)?.FirstName +
      " " +
      JSON.parse(value.amtaxsettlement_data)?.LastName
  );
};

const Email = (value) => {
  return value && JSON.parse(value.amtaxsettlement_data)?.Email;
};

const columnData = [
  { id: "_id", align: false, disablePadding: true, label: "#", order: 1 },
  {
    id: "Name",
    align: false,
    disablePadding: true,
    label: "Username",
    title: "Username",
    order: 1,
    type: "action",
    action: Name,
  },
  {
    id: "Email",
    align: true,
    disablePadding: false,
    label: "Email",
    title: "Email",
    order: 1,
    type: "action",
    action: Email,
  },
  {
    id: "action",
    align: true,
    disablePadding: false,
    title: "action",
    label: "Action",
  },
];
const FinanceFormIndex = () => {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState("");
  const [filterBy, setFilterBy] = useState("email");
  const [dragUsers, setDragUsers] = useState("");
  const [state, setState] = useState({
    orderBy: "sort_index",
    order: "asc",
    page: 0,
    limit: 10,
    // searchBy: "",
    // search: "",
    admin_id: "",
  });
  const adminId = localStorage.getItem("id");
  const subscriberData = useSelector((s) => s?.Customers?.user?.data);
  const loading = useSelector((s) => s.Customers?.loading);
  const totalCount = useSelector((s) => s.Customers?.user?.total_count);

  useEffect(() => {
    if (adminId) {
      setState((pre) => ({ ...pre, admin_id: adminId }));
    }
  }, [adminId]);

  useEffect(() => {
    if (subscriberData) {
      setDragUsers(subscriberData);
    }
  }, [subscriberData]);

  useEffect(() => {
    dispatch(customerList(state));
  }, [state]);
  const handleStatus = (e) => {
    e.preventDefault();
    const { value } = e.target;
    setFilterBy(value);
  };

  const filterdata = (e) => {
    e.preventDefault();
    let body = {
      ...state,
      search: filter,
      searchBy: filterBy,
    };
    dispatch(customerList(body));
  };

  const resetFilter = () => {
    setState((pre) => ({
      ...pre,
      search: "",
    }));
    setFilter("");
  };

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setFilter(value);
  };

  const handleChangePage = (event, page) => {
    setState((pre) => ({
      ...pre,
      page: page,
    }));
  };

  const handleDragEnd = (e) => {
    if (!e.destination) return;
    let tempData = Array.from(dragUsers);
    let [source_data] = tempData.splice(e.source.index, 1);
    tempData.splice(e.destination.index, 0, source_data);
    setDragUsers(tempData);

    let body = {
      id: e?.draggableId,
      current_index: JSON.stringify(e?.source?.index + 1),
      destination_index: JSON.stringify(e?.destination?.index + 1),
      action_on: "ats_financial_questionnaires",
    };
    dispatch(rowSorting(body));
  };

  return (
    <>
      <section className="dashboard py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <h4 className="dashboard-head m-0">Online Forms</h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <Filters
                status={state.status}
                columns={state.columns}
                filter={filter}
                handleStatus={handleStatus}
                handleSearchChange={handleSearchChange}
                filterdata={filterdata}
                resetFilter={resetFilter}
              />
              <div className="bg-white px-4 py-3 card-box">
                <div className="table-responsive py-3">
                  <DragDropContext onDragEnd={handleDragEnd}>
                    <DataTable className="">
                      <DataTableHead
                        columns={columnData}
                        orderBy={state.orderBy}
                        //   sort={handleRequestSort}
                      />
                      <Droppable droppableId="droppable-1">
                        {(provider) => (
                          <DataTableBody
                            loading={loading}
                            column={columnData}
                            data={dragUsers}
                            page={state.page}
                            rowsPerPage={state.limit}
                            innerRef={provider.innerRef}
                            dropProp={provider.droppableProps}
                            actionBtn={[
                              {
                                label: "Edit",
                                icon: "",
                                link: "/finance-form/edit",
                              },
                              {
                                label: "View",
                                icon: "",
                                link: "/finance-form/detail",
                              },
                            ]}
                          />
                        )}
                      </Droppable>
                    </DataTable>
                  </DragDropContext>
                  <div className="custom-pagination d-flex align-items-center w-100 justify-content-end">
                    <div className="main-pagination-drop d-flex gap-2 align-items-center">
                      <h6 className="row-per-page-heading m-0">
                        Rows per page:
                      </h6>
                      <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                          {state.limit}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() =>
                              setState((pre) => ({ ...pre, limit: 10 }))
                            }
                          >
                            10
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              setState((pre) => ({ ...pre, limit: 25 }))
                            }
                          >
                            25
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              setState((pre) => ({ ...pre, limit: 50 }))
                            }
                          >
                            50
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              setState((pre) => ({ ...pre, limit: 100 }))
                            }
                          >
                            100
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    {dragUsers?.length > 0 && (
                      <DataTablePagination
                        count={totalCount}
                        rowsPerPage={state.limit}
                        page={state.page}
                        onPageChange={handleChangePage}
                        rowsPerPageOptions={[]}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default FinanceFormIndex;
